import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokePoolHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokePoolHeater} />; }
